//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'

export default {
  props: {
    row: {
      type: Object,
      default () {
        return {}
      }
    },
    scheduleForEdit: {
      type: Array,
      default () {
        return []
      }
    },
    selectedDays: {
      type: Array,
      default () {
        return []
      }
    },
    startSetDays: {
      type: Function,
      default () {
        return () => {}
      }
    },
    editDay: {
      type: Function,
      default () {
        return () => {}
      }
    },
    selectedRows: {
      type: Array,
      default () {
        return []
      }
    },
    currentDayIndex: {
      type: Number,
      default: null
    },
    workerIndex: {
      type: Number,
      default: null
    },
    userId: {
      type: Number,
      default: null
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    showBrigades: {
      type: Boolean,
      default: false
    },
    showOvertimeTariffs: {
      type: Boolean,
      default: false
    },
    isCurrentUser: {
      type: Boolean,
      default: false
    },
    getOvertimeTariffName: {
      type: Function,
      default: () => {}
    },
    isAnotherMonth: {
      type: Function,
      default: () => {}
    },
    overtimeTariffs: {
      type: Array,
      default () {
        return []
      }
    },
    additionalOvertimeTariffs: {
      type: Array,
      default () {
        return []
      }
    },
    overtimesGroupByValue: {
      type: Array,
      default () {
        return []
      }
    },
    workShifts: {
      type: Array,
      default () {
        return []
      }
    },
    hideOtherWorkAreaOvertimes: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    workShiftColors: function () {
      const colors = {}
      this.workShifts.forEach(wsh => {
        colors[wsh.key] = {
          color: wsh.color,
          fontColor: wsh.fontColor
        }
      })
      return colors
    }
  },
  methods: {
    showAnotherRoleHelpDialog: function () {
      this.$d_ask({
        callback: async (data, action) => {
        },
        header: 'Пояснение',
        warning: 'Необходимо уточнить состав ролей для включения сотрудника в группы полевых/офисных сотрудников и корректного отображения в рабочем календаре.',
        buttons: {
          ok: 'ОK'
        }
      })
    },
    getAllDayWorkShifts: function (record) {
      let allDayWorkShifts = [record]
      if (record.additionalWorkShifts && record.additionalWorkShifts.length) {
        if (this.onlyAdditionalWorkShifts(record)) {
          allDayWorkShifts = [...record.additionalWorkShifts]
        } else {
          allDayWorkShifts = [record, ...record.additionalWorkShifts]
        }
      }

      return allDayWorkShifts
    },
    onEditDay: function (record, row) {
      if (this.isEditable(record)) {
        this.editDay(row, record)
      }
    },
    onStartSetDays: function (record, row) {
      if (this.isEditable(record)) {
        this.startSetDays(record, row)
      }
    },
    openEmployeeCard: function (event, employee) {
      event.stopPropagation()
      this.$d_showObjectCard(employee.id, 'employee', event.ctrlKey)
    },
    hideOvertimes: function (record) {
      if (this.user.employee && this.row.id === this.user.employee.id) {
        return false
      }

      if (this.row.redirected && !this.isRedirectedDay(record)) {
        return true
      }

      if (!this.user.employee || !this.user.employee.defaultWorkAreas || !this.hideOtherWorkAreaOvertimes) {
        return false
      }

      let hideOvertimes = true
      this.user.employee.defaultWorkAreas.forEach(workArea => {
        const rowWorkArea = record && this.isRedirectedDay(record) ? record.redirectedWorkArea : this.row.workArea
        if (rowWorkArea && rowWorkArea.includes(workArea)) {
          hideOvertimes = false
        }
      })

      return hideOvertimes
    },
    displayComment: function (record) {
      if (typeof record.comment === 'object' && record.comment !== null) {
        return !!record.comment.comment
      } else {
        return !!record.comment
      }
    },
    displayCommentOvertime: function (record) {
      const allDayWorkShifts = this.getAllDayWorkShifts(record)
      return (!!allDayWorkShifts[0].overtimeTariffComment || !!allDayWorkShifts[allDayWorkShifts.length - 1].overtimeTariffComment) && !this.hideOvertimes(record)
    },
    displayOvertime: function (record) {
      const allDayWorkShifts = this.getAllDayWorkShifts(record)

      return (allDayWorkShifts[0].overtimeBefore || allDayWorkShifts[0].overtimeWorkShift || allDayWorkShifts[allDayWorkShifts.length - 1].overtimeAfter) && !this.hideOvertimes(record)
    },
    hasAdditionalWorkShifts: function (record) {
      return record.additionalWorkShifts && record.additionalWorkShifts.length
    },
    isSelectedDay: function (dayIndex) {
      return this.selectedDays.includes(dayIndex)
    },
    selectRow: function () {
      const rowKey = this.row.groupWorkArea + '_' + this.row.id
      const index = this.selectedRows.indexOf(rowKey)
      if (index !== -1) {
        this.selectedRows.splice(index, 1)
      } else {
        this.selectedRows.push(rowKey)
      }
    },
    isSelectedRow: function () {
      const rowKey = this.row.groupWorkArea + '_' + this.row.id
      return this.selectedRows.includes(rowKey) || this.isCurrentUser
    },
    isSelectedRowAndDay: function (dayIndex) {
      return this.isSelectedDay(dayIndex) && this.isSelectedRow()
    },
    getRecordOvertime: function (record) {
      const allDayWorkShifts = this.getAllDayWorkShifts(record)

      let overtime = 0
      if (allDayWorkShifts[0].overtimeBefore) {
        overtime += allDayWorkShifts[0].overtimeBefore
      }
      if (allDayWorkShifts[0].overtimeWorkShift) {
        overtime += allDayWorkShifts[0].overtimeWorkShift
      }
      if (allDayWorkShifts[allDayWorkShifts.length - 1].overtimeAfter) {
        overtime += allDayWorkShifts[allDayWorkShifts.length - 1].overtimeAfter
      }
      return overtime
    },
    getWorkShiftShortName: function (record) {
      let name = ''
      if (this.isCompensatoryHoliday(record)) {
        name = 'Отг.'
      } else if (this.isIllness(record)) {
        name = 'Б'
      } else if (this.isAnother(record)) {
        name = 'Н'
      } else if (this.isDismiss(record)) {
        name = 'У'
      } else if (this.isSuspended(record)) {
        name = 'Отстр.'
      } else if (this.isRemote(record)) {
        name = 'У'
      } else if (this.isNotAllowed(record)) {
        name = 'Н/Д'
      } else if (this.isVacation(record)) {
        name = 'Отп.'
      } else if (this.isMobilized(record)) {
        name = 'М'
      } else if (record.startHour != null && record.endHour != null && (record.startHour !== 0 || record.endHour !== 0)) {
        name = record.startHour + '-' + record.endHour % 24
      }

      return name
    },
    getRecordShortName: function (record, dayIndex) {
      let name = this.getWorkShiftShortName(record)

      if (this.hasAdditionalWorkShifts(record)) {
        record.additionalWorkShifts.forEach((additionalWorkShift, index) => {
          if (index === 0 && this.onlyAdditionalWorkShiftsByIndex(dayIndex)) {
            name += '+'
            name += this.getWorkShiftShortName(additionalWorkShift)
          } else {
            name += '+д'
          }
        })
      }

      if (this.nextDayOnlyAdditionalWorkShiftsByIndex(dayIndex)) {
        name += '+'
      }

      return name
    },
    nextDayOnlyAdditionalWorkShiftsByIndex: function (dayIndex) {
      return this.onlyAdditionalWorkShiftsByIndex(dayIndex + 1)
    },
    onlyAdditionalWorkShiftsByIndex: function (dayIndex) {
      return this.row.schedule[dayIndex] && this.onlyAdditionalWorkShifts(this.row.schedule[dayIndex])
    },
    onlyAdditionalWorkShifts: function (record) {
      return record && this.hasAdditionalWorkShifts(record) && record.dayoff
    },
    isEditable: function (record) {
      if (!record.dayMatched) {
        return false
      }

      if (this.row.redirected) {
        let editable = false
        if (record.redirectedWorkArea) {
          record.redirectedWorkArea.forEach((redirectedWorkArea) => {
            if (this.row.groupWorkArea.includes(redirectedWorkArea)) {
              editable = true
            }
          })
        }
        return editable
      } else {
        // TO DO: В форме редактирование предупреждения не вижу.
        // Предупреждение в форме редактирования, а не полностью запрещать
        // return !record.redirectedWorkArea || !record.redirectedWorkArea.length
        return true
      }
    },
    getCountOfDayBadge: function (record) {
      let count = 0
      if (this.isRedirectedDay(record)) {
        count++
      }
      if (this.hasDriverDuration(record)) {
        count++
      }
      if (this.isDisplayAdditionalStatus(record)) {
        count++
      }
      if (this.displayOvertime(record)) {
        count++
      }
      return count
    },
    isRedirectedDay: function (record) {
      return !!record && record.redirectedWorkArea && record.redirectedWorkArea.length
    },
    getReasonNotEditable: function (record) {
      let text = ''

      if (!record.dayMatched) {
        text += 'Смена дня не соответствует фильтру.'
        return text
      }

      if (this.row.redirected) {
        text += 'Сотрудник работает в другом направлении.'
      }

      return text
    },
    getDayStatusClass: function (record) {
      if (this.onlyAdditionalWorkShifts(record)) {
        return this.getWorkShiftClass(record.additionalWorkShifts[0])
      } else {
        return this.getWorkShiftClass(record)
      }
    },
    getWorkShiftClass: function (workShift) {
      if (this.isWorkShift(workShift)) {
        return ''
      }

      if (this.isIllness(workShift) || this.isAnother(workShift) || this.isNotAllowed(workShift) || this.isSuspended(workShift)) {
        if (this.isWorking(workShift)) {
          return 'absence-workday'
        } else {
          return 'absence-dayoff'
        }
      } else if (this.isDismiss(workShift)) {
        return 'dismiss'
      } else if (this.isCompensatoryHoliday(workShift) || this.isVacation(workShift)) {
        if (this.isWorking(workShift)) {
          return 'holiday-workday'
        } else {
          return 'holiday-dayoff'
        }
      } else if (this.isMobilized(workShift)) {
        if (this.isWorking(workShift)) {
          return 'mobilized-workday'
        } else {
          return 'mobilized-dayoff'
        }
      } else {
        return 'empty-data'
      }
    },
    getDayStyle: function (record) {
      if (this.onlyAdditionalWorkShifts(record)) {
        return this.getWorkShiftStyle(record.additionalWorkShifts[0])
      } else {
        return this.getWorkShiftStyle(record)
      }
    },
    getWorkShiftStyle: function (workShift) {
      if (!this.isWorkShift(workShift)) {
        return ''
      }

      let color = null
      let fontColor = null
      if (workShift.workShift && this.workShiftColors[workShift.workShift]) {
        color = this.workShiftColors[workShift.workShift].color
        fontColor = this.workShiftColors[workShift.workShift].fontColor
      } else if (this.workShiftColors['brigadier.custom']) {
        color = this.workShiftColors['brigadier.custom'].color
        fontColor = this.workShiftColors['brigadier.custom'].fontColor
      }
      return 'background-color: ' + color + '; color: ' + fontColor + ';'
    },
    isWorkShift: function (record) {
      return !this.isIllness(record) &&
            !this.isAnother(record) &&
            !this.isNotAllowed(record) &&
            !this.isSuspended(record) &&
            !this.isDismiss(record) &&
            !this.isCompensatoryHoliday(record) &&
            !this.isVacation(record) &&
            !this.isMobilized(record) &&
            this.isWorking(record)
    },
    isCompensatoryHoliday: function (record) {
      return record.compensatoryHoliday
    },
    isWorking: function (record) {
      return record.dayoff != null && !record.dayoff
    },
    isIllness: function (record) {
      return record.absent && record.absent.length == 1 && record.absent[0].reason == 'illness' &&
        record.absent[0].startTime == null && record.absent[0].endTime == null
    },
    isAnother: function (record) {
      return record.absent && record.absent.length == 1 && record.absent[0].reason == 'another' &&
        record.absent[0].startTime == null && record.absent[0].endTime == null
    },
    hasDriverDuration: function (record) {
      let driverByDuration = record.driverByDuration
      if (this.hasAdditionalWorkShifts(record)) {
        record.additionalWorkShifts.forEach(additionalWorkShift => {
          driverByDuration = driverByDuration || additionalWorkShift.driverByDuration
        })
      }
      return driverByDuration
    },
    isDisplayAdditionalStatus: function (record) {
      if (this.onlyAdditionalWorkShifts(record)) {
        record = record.additionalWorkShifts[0]
      }
      return record.mission || record.workoff || record.replacement
    },
    getAdditionalStatusShortName: function (record) {
      if (this.onlyAdditionalWorkShifts(record)) {
        record = record.additionalWorkShifts[0]
      }
      if (record.mission) {
        return 'к'
      } else if (record.workoff) {
        return 'о'
      } else if (record.replacement) {
        return 'п'
      }
      return ''
    },
    getTooltipOvertime: function (record) {
      const allDayWorkShifts = this.getAllDayWorkShifts(record)

      const overtimeTexts = []
      if (allDayWorkShifts[0].overtimeBefore) {
        overtimeTexts.push(allDayWorkShifts[0].overtimeBefore + ' (до)')
      }
      if (allDayWorkShifts[0].overtimeWorkShift) {
        overtimeTexts.push(allDayWorkShifts[0].overtimeWorkShift + ' (сверхурочная)')
      }
      if (allDayWorkShifts[allDayWorkShifts.length - 1].overtimeAfter) {
        overtimeTexts.push(allDayWorkShifts[allDayWorkShifts.length - 1].overtimeAfter + ' (после)')
      }
      return overtimeTexts.join(' + ')
    },
    getTooltipOvertimeComment: function (record) {
      const allDayWorkShifts = this.getAllDayWorkShifts(record)
      const overtimeCommentTexts = []
      if (allDayWorkShifts[0].overtimeTariffComment) {
        overtimeCommentTexts.push(allDayWorkShifts[0].overtimeTariffComment + (allDayWorkShifts.length > 1 ? ' (до)' : ''))
      }
      if (allDayWorkShifts.length > 1 && allDayWorkShifts[allDayWorkShifts.length - 1].overtimeTariffComment) {
        overtimeCommentTexts.push(allDayWorkShifts[allDayWorkShifts.length - 1].overtimeTariffComment + ' (после)')
      }
      return overtimeCommentTexts.join(' + ')
    },
    getAdditionalWorkShifts: function (record) {
      return record.additionalWorkShifts.map(additionalWorkShift => {
        if (additionalWorkShift.workShift != null) {
          const regularWorkShift = this.workShifts.find(workShift => workShift.key === additionalWorkShift.workShift)
          if (regularWorkShift) {
            return regularWorkShift.name
          } else {
            const hours = additionalWorkShift.workShift.split('.')[1].split('-')
            const startHour = hours[0] + (hours[0].includes(':') ? '' : ':00')
            const endHour = hours[1] + (hours[1].includes(':') ? '' : ':00')
            const name = `с ${startHour} по ${endHour}`
            return name || this.workShifts.find(workShift => workShift.key === 'brigadier.custom').name
          }
        }
      }).join(', ')
    },
    isVacation: function (record) {
      return record.vacation
    },
    isMobilized: function (record) {
      return record.mobilized
    },
    isNotAllowed: function (record) {
      return record.notAllowed
    },
    isSuspended: function (record) {
      return record.suspended
    },
    isRemote: function (record) {
      return record.remote
    },
    isDismiss: function (record) {
      return record.dismiss === true
    },
    isCurrent: function (dayIndex) {
      return dayIndex === this.currentDayIndex
    },
    isScheduleForEdit: function (day, worker) {
      const indexWorker = this.scheduleForEdit.map(worker => worker.id).indexOf(worker.id)

      if (indexWorker !== -1) {
        const schedule = this.scheduleForEdit[indexWorker].schedule
        return schedule.includes(day)
      }
      return false
    },
    isBrigadeActive: function (worker) {
      if (this.currentDayIndex !== null && worker.schedule[this.currentDayIndex] && worker.schedule[this.currentDayIndex].brigade && worker.schedule[this.currentDayIndex].brigade.name) {
        return worker.schedule[this.currentDayIndex].isBrigadeActive
      } else {
        return false
      }
    },
    getOvertimeHoursByTariffId: function (overtimes, tariffId) {
      return overtimes && overtimes[tariffId] ? Math.round(overtimes[tariffId] / (1000 * 60 * 60) * 10) / 10 : 0
    }
  }
}

